import { Col, ColType, Crud, CrudOption, CrudApi } from "../../comp/crud";
import {
    ApiClient,
    displayRepaymentPlanStatus, getRepaymentPlanStatusOpt, displayPaidMethod, getPaidMethodOpt
} from "../../api/ApiClient";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Typography,
    Image,
    Tag,
    Button,
    Descriptions,
    Row,
    Tooltip,
    Toast,
    Popover,
    Modal,
    Table,
    TextArea,
    Badge
} from '@douyinfe/semi-ui';
import { IconBarChartHStroked, IconCoinMoneyStroked, IconHelpCircle } from "@douyinfe/semi-icons";
import { formatAmountZhCn, formatDate, renderPlatformTooltip, renderStatDetailContentPlan, renderRepaymentPlanStatusTag, renderPaidMethodTag, renderPeriodNo, renderReviewStatusTag, renderStatusTransition, ConfirmStatusOptions } from "../../utils";
import dayjs from "dayjs";
import { Col as RowCol } from "@douyinfe/semi-ui/lib/es/grid";

let apiClient = ApiClient.getDefault();
const { Text } = Typography;

export interface OutMoneyPlanProps {
    leadId?: number;
    leadName?: string;
    outMoneyUserId?: string;
    platform?: string;
    leadCity?: string;

}
export default function OutMoneyPlan(props: OutMoneyPlanProps) {

    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    const crudApiRef = useRef<CrudApi>();
    const filterFormRef = useRef<any>();

    // 当前登录用户信息（用于权限校验）
    const currentUserId = localStorage.getItem("userId");
    const currentRole = localStorage.getItem("role");
    // 按揭主管只能看自己团队的，可以审核数据
    const isAdmin = currentRole === "root" || currentRole === "op_manager" || currentRole === "agent_manager";

    const [statData, setStatData] = useState([] as any[]);
    const [statDataObj, setStatDataObj] = useState({} as any);

    const [filterLeadId, setFilterLeadId] = useState(true);
    const [filterLeadName, setFilterLeadName] = useState(true);
    const [filterOutMoneyUserId, setFilterOutMoneyUserId] = useState(true);
    const [filterPlatform, setFilterPlatform] = useState(true);
    const [filterLeadCity, setFilterLeadCity] = useState(true);

    // ====== 审批流日志弹窗状态 ======
    const [confirmLogModalVisible, setConfirmLogModalVisible] = useState(false);
    const [confirmLogRecord, setConfirmLogRecord] = useState<any>(null);
    const [confirmLogs, setConfirmLogs] = useState<any[]>([]);
    const [rejectModalVisible, setRejectModalVisible] = useState(false);
    const [rejectRecord, setRejectRecord] = useState<any>(null);
    const [rejectReason, setRejectReason] = useState("");

    // ====== 确认状态筛选按钮 ======
    const [activeConfirmFilter, setActiveConfirmFilter] = useState<string>("");
    const [confirmStatusCounts, setConfirmStatusCounts] = useState<any>({ PENDING: 0, REJECTED: 0, CANCEL: 0, EDIT: 0 });

    /**
     * 显示确认日志弹窗
     */
    const showConfirmLogModal = (record: any) => {
        setConfirmLogRecord(record);
        setConfirmLogs([]);
        setConfirmLogModalVisible(true);
        apiClient
            .request("/repaymentPlan/confirmLogs", "GET", { repaymentPlanId: record.id })
            .then((resp: any) => {
                setConfirmLogs(resp.data || []);
            });
    };

    /**
     * 点击确认状态筛选按钮
     */
    const handleConfirmFilterClick = (status: string) => {
        const newStatus = activeConfirmFilter === status ? "" : status;
        setActiveConfirmFilter(newStatus);
        // 设置Crud筛选条件
        const formApi = filterFormRef.current;
        if (formApi) {
            formApi.setValue('status', newStatus || undefined);
        }
        crudApi?.refresh();
    };

    /**
     * 出款人确认操作（统一确认入口）
     * 权限校验：仅出款人本人、root、op_manager 可操作
     * 状态机处理：
     * - PENDING → YJQ
     * - EDIT → YJQ（应用编辑数据）
     * - CANCEL → null（真正取消还款）
     */
    const handleConfirmAll = (row: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一条记录");
            return;
        }
        // 权限校验：非管理员时，只能操作自己作为出款人的记录
        if (!isAdmin) {
            const noPermissionRows = rows.filter((item: any) => String(item.paidUserId) !== currentUserId);
            if (noPermissionRows.length > 0) {
                Toast.warning(`有 ${noPermissionRows.length} 条记录的出款人不是您，无权操作`);
                return;
            }
        }
        const validRows = rows.filter((item: any) =>
            item.status === "PENDING" || item.status === "CANCEL" || item.status === "EDIT"||item.status == "VR_YJQ"||item.status == "VR_YGZ"

        );

        if (validRows.length === 0) {
            Toast.info("没有可确认的记录(仅待审核/取消中/编辑中状态可确认)");
            return;
        }

        const parts: string[] = [];
        const pendingCount = validRows.filter((i: any) => i.status === "PENDING").length;
        const cancelCount = validRows.filter((i: any) => i.status === "CANCEL").length;
        const editCount = validRows.filter((i: any) => i.status === "EDIT").length;
        if (pendingCount > 0) parts.push(`${pendingCount}条待确认`);
        if (cancelCount > 0) parts.push(`${cancelCount}条取消中`);
        if (editCount > 0) parts.push(`${editCount}条编辑中`);

        Modal.confirm({
            title: "确认",
            content: `是否确认选中的 ${parts.join('、')} 记录?`,
            onOk: async () => {
                try {
                    const ids = validRows.map((item: any) => item.id);
                    const resp: any = await apiClient.request("/repaymentPlan/confirmRepayment", "POST", null, { ids });
                    const result = resp?.data || resp;
                    if (result && result.fail > 0) {
                        const reasons = (result.errors || []).map((e: any) => `#${e.id}: ${e.reason}`).join('；');
                        Toast.warning(`成功${result.success}条，失败${result.fail}条：${reasons}`);
                    } else {
                        Toast.success(`确认成功，共${result?.success || validRows.length}条`);
                    }
                    crudApi?.refresh();
                } catch (e) {
                    Toast.error("请求失败");
                }
            },
        });
    };

    /**
     * 出款人驳回还款 - 打开驳回原因弹窗
     * 权限校验：仅出款人本人、root、op_manager 可操作
     * 状态机处理：
     * - PENDING → REJECTED
     * - EDIT → YJQ（回退编辑）
     * - CANCEL → 恢复之前状态
     */
    const handleReject = (row: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一条记录");
            return;
        }
        // 权限校验：非管理员时，只能操作自己作为出款人的记录
        if (!isAdmin) {
            const noPermissionRows = rows.filter((item: any) => String(item.paidUserId) !== currentUserId);
            if (noPermissionRows.length > 0) {
                Toast.warning(`有 ${noPermissionRows.length} 条记录的出款人不是您，无权操作`);
                return;
            }
        }
        const validRows = rows.filter((item: any) =>
            item.status === "PENDING" || item.status === "EDIT" || item.status === "CANCEL"
        );
        if (validRows.length === 0) {
            Toast.info("没有可驳回的记录(仅待确认/编辑中/取消中状态可驳回)");
            return;
        }
        setRejectRecord(validRows);
        setRejectReason("");
        setRejectModalVisible(true);
    };

    /**
     * 提交驳回
     */
    const doReject = async () => {
        if (!rejectReason.trim()) {
            Toast.info("请填写驳回原因");
            return;
        }
        try {
            const ids = rejectRecord.map((item: any) => item.id);
            const resp: any = await apiClient.request("/repaymentPlan/rejectRepayment", "POST", null, { ids, rejectReason });
            const result = resp?.data || resp;
            if (result && result.fail > 0) {
                const reasons = (result.errors || []).map((e: any) => `#${e.id}: ${e.reason}`).join('；');
                Toast.warning(`成功${result.success}条，失败${result.fail}条：${reasons}`);
            } else {
                Toast.success(`驳回成功，共${result?.success || ids.length}条`);
            }
            setRejectModalVisible(false);
            crudApi?.refresh();
        } catch (e) {
            Toast.error("请求失败");
        }
    };

    const getLoanStatusOpt = (): CrudOption[] => {
        let items = [
            {
                label: "全部",
                value: "",
                key: "0",
            },
            {
                label: "贷款中",
                value: "LOANING",
                key: "1",
            },
            {
                label: "已坏账",
                value: "BAD_DEPT",
                key: "2",
            },
            {
                label: "已释放",
                value: "SETTLED",
                key: "3",
            },
        ];
        return items;
    };

    const renderInterestDesc = (text: string, row: any) => {
        let detail = row.planInterestDetail;
        if (!detail) {
            return '-'
        }
        else if (!detail.interestStartDate) {

            return (
                <>
                    <span></span><Tag>{detail.interestAmount} * {detail.interestRate} </Tag>
                </>
            );
        } else {
            return (
                <>
                    <span>{formatDate(detail.interestStartDate)}至{formatDate(detail.interestEndDate)}({detail.interestEndDateDesc}) </span><Tag>{detail.interestAmount} * {detail.interestRate} * {detail.interestDays}天</Tag>
                </>
            );
        }

    };


    let cols: Col[] = [
        {
            name: "贷款状态",
            key: "loanStatus",
            colFilterSort: 0,
            showInFilter: true,
            hideInCreate: true,
            hideInList: true,
            type: ColType.SELECT,
            getOptions: () => Promise.resolve(getLoanStatusOpt()),
        },
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            hideInCreate: true,
            hideInList: true,
            type: ColType.NUMBER
        },

        {
            name: "客户ID",
            key: "leadId",
            width: 90,
            showInFilter: filterLeadId,
            type: ColType.NUMBER,
            hideInEdit: true,
            hideInList: true,
        },
        {
            name: "客户姓名",
            key: "leadName",
            width: 90,
            type: ColType.STRING,
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: filterLeadName,
            render: (value, record, index) => {
                return (
                    <>
                    <Tooltip content={<div>按揭专员: {record.agentName}<br/>销售: {record.saleName}</div>}>
                    <Typography.Text
                        link
                        type="primary"
                        onClick={() => openMortgageLoanModal(record.leadId,record.leadName)}
                    >
                        {value}({record.leadId})
                    </Typography.Text>
                    </Tooltip>
                    </>
                );

            },

        },
        {
            name: "城市",
            key: "leadCity",
            width: 60,
            type: ColType.SELECT,
            getOptions: () => apiClient.getDictAsOpts("city"),
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: filterLeadCity,

        },

        {
            name: "按揭专员ID",
            key: "agentId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "按揭专员",
            key: "agentName",
            width: 90,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
            hideInList: true,
        },
        {
            name: "销售ID",
            key: "saleId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "销售",
            key: "saleName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
            hideInList: true,
        },
        {
              name: "贷款平台",
              key: "platform",
              width: 150,
              type: ColType.STRING,
              showInFilter: true,
              render: (text: any, record: any) => (
                <Tooltip style={{maxWidth:350}} content={renderPlatformTooltip(record)}>
                    <Typography.Text mark>{text || "-"}</Typography.Text>
                    
                </Tooltip>
              ),
        },
        {
              name: "期数",
              key: "periodNo",
              width: 70,
              type: ColType.STRING,
              // 期数渲染: 手动创建的(蓝Tag)、客户自还的(橙Tag)、系统生成的(纯文本)
              render: renderPeriodNo
            },
           
            {
              name: "还款日期",
              key: "dueDate",
              width: 90,
              type: ColType.DATE_RANGE,     // 日期范围筛选，筛选时转为 "startDate,endDate"
              showInFilter: true,
              defaultSortOrder: false,
            },
            {
            name: "应还金额",
            key: "oneTermAmount",
            width: 90,
            type: ColType.NUMBER,
            render: (value, record, index) => {
                return (
                   
                        <span>{formatAmountZhCn(value)}</span>
                   
                );
            },
        },
             {
            name: "状态",
            key: "status",
            width: 70,
            render: (value, record, index) => (
                <span onClick={() => showConfirmLogModal(record)} style={{ cursor: 'pointer' }}>
                    {renderRepaymentPlanStatusTag(value, record)}
                </span>
            ),
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            getOptions: (row) => Promise.resolve(getRepaymentPlanStatusOpt())
        },
        {
            name: "待审核金额",
            key: "pendingAmount",
            width: 90,
            type: ColType.NUMBER,
            render: (value, record, index) => {
                return (
                   
                        <span>{formatAmountZhCn(value)}</span>
                   
                );
            },
        },
       
        {
            name: "出款金额",
            key: "expense",
            width: 90,
            type: ColType.NUMBER,
            render: (value, record, index) => {
                return (
                   
                        <span>{formatAmountZhCn(record.loanHelpRepaymentPlanAmount+record.cardHelpRepaymentPlanAmount
                            +record.borrowAmount)}</span>
                   
                );
            },
        },
       
        {
                    name: "信用卡代过账",
                    key: "postingHelpAmount",
                    width: 90,
                    type: ColType.NUMBER,
                    hideInList: false,
                    render: (a) => formatAmountZhCn(a),
                },
        {
            name: "出款人",
            key: "paidUserName",
            width: 80,
            type: ColType.STRING,
            hideInCreate: true,
            render: (value, record, index) => {
                if (record.loanType == 'BORROW') {
                    return (
                        <Text>{record.borrowerName}</Text>
                    );
                } else {
                    return (
                        <Text>{record.paidUserName}</Text>
                    );
                }
            },
        },
        {
            name: "出款人",
            key: "outMoneyUserName",
            width: 80,
            type: ColType.STRING,
            showInFilter: filterOutMoneyUserId,
            hideInList: true,

        },
        {
            name: "出款日期",
            key: "paidDate",
            width: 110,
            type: ColType.DATE_RANGE,
            hideInCreate: true,
            showInFilter: true,
            defaultSortOrder: "descend",
            render: (value, record, index) => {
                if (record.loanType == 'BORROW') {
                    return (
                        <Text>{record.borrowDate}</Text>
                    );
                } else {
                    return (
                        <Text>{record.paidDate}</Text>
                    );
                }
            },
        },
        {
              name: "还款图片",
              key: "imageUrls",
              width: 70,
              type: ColType.STRING,
              hideInCreate: true,
              render: (value, record, index) => {
                      if(value){
                         return    ( <Image
                                  width={50}
                                  height={50}
                                  src={record.imageUrls && record.imageUrls.length > 0 ? record.imageUrls[0].url : ''}
                                  preview={{
                                      src: (record.imageUrls || []).map(item => item.url)
                                  }}
                              /> )
                                }else {
                                  return '';
                                }
                    } 
            },
        
        {
            name: "还款方式",
            key: "paidMethod",
            width: 100,
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            render: (value) => renderPaidMethodTag(value),
            getOptions: (row) => Promise.resolve(getPaidMethodOpt())
        },
        {
            name: '利息',
            key: 'interestAmount',
            width: 70,
            type: ColType.TEXT,
            showInFilter: false,
            hideInEdit: true,
            hideInCreate: true,
            render: (value: number) => (
                <Text type="warning">
                    {formatAmountZhCn(value || 0)}
                </Text>
            )
        },
        {
            name: '利息计算',
            key: 'interestAmount',
            width: 160,
            type: ColType.TEXT,
            showInFilter: false,
            hideInEdit: true,
            hideInCreate: true,
            render: renderInterestDesc
        },
         {
            name: "贷款金额",
            key: "amount",
            width: 90,
            type: ColType.NUMBER,
            hideInList: true,
            render: (a) => formatAmountZhCn(a),
        },
        {
            name: "还款天数",
            key: "paidDays",
            width: 90,
            type: ColType.NUMBER,
            hideInCreate: true,
        },
        {
              name: "日利率",
              key: "interest",
              width: 60,
              type: ColType.STRING,
              render: (value, record, index) => {
                            return (
                                <Tooltip style={{maxWidth: 450}} content={<div>
                                    贷款利率: {record.interest }<br/>
                                    信用卡利率: {record.borrowInterest}<br/>
                                    借款利率: {record.postingInterest }<br/>
                                   
                                </div>}>
                                    <Typography.Text mark>{value}</Typography.Text>
                                </Tooltip>
                            );
                        },
            },
        {
            name: "贷款编号",
            key: "loanNo",
            type: ColType.STRING,
            showInFilter: true,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
            width: 110,
        },
        
    ]



    //打开详情
    const detailAction = (a: any) => {
        const w = window.open("about:blank");
        let queryParams = {
            ...crudApi?.getQueryParams(),
            type: 'all'
        }
        if (w != null) {
            //获取表格data的id列表
            const ids = crudApi?.getData()?.map((i) => i.leadId);
            const data = {
                id: a.leadId,
                ids: ids,
                viewMode: true,
                visitMode: false,
                leadFrom: 'report',
                queryParams: queryParams,
            };
            w.location.href =
                "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
        }
    };

    // 功能12: 打开贷款详情页面
  // 跳转到新窗口 /#/newleadLoan，传入客户ID和姓名
  // 对应二级页面 indexMortgageLoan.tsx (entityKey: mortgageLoan/listGroupPlatform)
  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    //setLeadId(leadId);
    //setMortgageLoanShow(true);
    //打开客户贷款
    const w = window.open("about:blank");
    if (w != null) {
      //获取表格data的id列表
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

    let nowDate = new Date();
    //计算nowDate的所在月份的第一天和最后一天
    let startDate = new Date(nowDate.getFullYear(), nowDate.getMonth() - 1, 1);
    let endDate = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
    const [initFilterValues, setInitFilterValues] = useState({
        paidDate: [startDate, endDate],
    });
    let startDateStr = formatDate(startDate);
    let endDateStr = formatDate(endDate);
    const initParams = {
        paidDate: startDateStr + "," + endDateStr,
    };

    useEffect(() => {
        if (props.leadId) {
            setFilterLeadId(false);
        }
        if (props.leadName && props.leadName != "") {
            setFilterLeadName(false);
        }
        if (props.outMoneyUserId && props.outMoneyUserId != "") {
            setFilterOutMoneyUserId(false);
        }
        if (props.platform && props.platform != "") {
            setFilterPlatform(false);
        }
        if (props.leadCity && props.leadCity != "") {
            setFilterLeadCity(false);
        }

        //刷新统计
        initStatCountData();
    }, [statDataObj]);

    const queryStatCount = async (data: any) => {
        let params = {
            ...data,
        };
        console.log("统计报表查询参数：", params);
        apiClient.request("/repaymentPlan/listPaidSum", "GET", data).then((resp) => {
            setStatDataObj(resp.data);
        });
    };

    const queryConfirmStatusCount = async (data: any) => {
    apiClient.request("/repaymentPlan/confirmStatusCountCkmx", "GET", data).then((resp) => {
      setConfirmStatusCounts(resp.data);
    });
  };

    const initStatCountData = async () => {
        console.log("统计报表返回数据：", statDataObj);
        if (!statDataObj) {
            return;
        }

        const data = [
            { key: "", value: "汇总" },
            {
                key: "借贷金额",
                value: formatAmountZhCn(statDataObj.amount),
            },
            {
                key:"代过账金额",
                value: formatAmountZhCn(statDataObj.cardHelpPostingPlanAmount )

            },
            {
                key: (
                    <Tooltip
                        style={{ maxWidth: 400 }}
                        content={"出款金额 = 贷款代还 + 信用卡代还 + 借款金额"}
                    >出款金额
                        <IconHelpCircle
                            style={{
                                color: "#E91E63",
                            }}
                        />
                    </Tooltip>
                ),
                value: formatAmountZhCn(statDataObj.loanHelpRepaymentPlanAmount + statDataObj.cardHelpRepaymentPlanAmount  + statDataObj.borrowAmount)

            },
            
            {
                key: "个人借款金额",
                value: formatAmountZhCn(statDataObj.borrowAmount)

            },
            {
                key: "个人借款已还金额",
                value: formatAmountZhCn(statDataObj.borrowReturnAmount),

            },
             {
                key: (
                    <Tooltip
                        style={{ maxWidth: 400 }}
                        content={"支出合计 = 贷款代还 + 信用卡代还  + 个人借款 - 个人借款已还"}
                    >支出合计
                        <IconHelpCircle
                            style={{
                                color: "#E91E63",
                            }}
                        />
                    </Tooltip>
                ),
                value: <span
                    style={{
                        color: "#E91E63",
                    }}
                >{formatAmountZhCn(statDataObj.paidAmount)}</span>

            },
           

        ];
        setStatData(data);
    };



    const listSumStat = () => {
        const style = {
            boxShadow: "var(--semi-shadow-elevated)",
            backgroundColor: "var(--semi-color-bg-2)",
            borderRadius: "4px",
            padding: "10px",
            margin: "auto",
        };
        return (
            <div style={{ display: "flex", width: "100%", margin: "5px", alignItems: "center" }}>
                <Popover
                    content={renderStatDetailContentPlan(statDataObj)}
                    trigger="hover"
                    position="bottomLeft"
                    showArrow
                >
                    <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked style={{marginRight: 4}}/>统计详情</a>
                </Popover>
                <Descriptions data={statData} row style={style} />
            </div>
        );
    };

    const applyQuickDate = (startDate: Date, endDate: Date) => {
        const api = crudApiRef.current;
        if (!api) { Toast.info('页面加载中，请稍后再试'); return; }
        const formApi = filterFormRef.current;
        if (formApi) formApi.setValue('paidDate', [startDate, endDate]);
        api.refresh();
    };

    const PaidDateQuickButtons = () => {
        const today = new Date();
        const nearDays = [
            { label: '近3天', days: 3 },
            { label: '近7天', days: 7 },
            { label: '近15天', days: 15 },
        ];
        const months = Array.from({ length: 5 }, (_, i) => {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            return {
                label: `${d.getMonth() + 1}月`,
                start: new Date(d.getFullYear(), d.getMonth(), 1),
                end: new Date(d.getFullYear(), d.getMonth() + 1, 0),
            };
        });
        return (
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', margin: '4px 0 2px', flexWrap: 'wrap' }}>
                <span style={{ color: 'var(--semi-color-text-2)', fontSize: 12, fontWeight: 500 }}>出款日期:</span>
                {nearDays.map(item => {
                    const s = new Date(today); s.setDate(s.getDate() - item.days);
                    return <Button key={item.label} size="small" theme="light" onClick={() => applyQuickDate(s, today)}>{item.label}</Button>;
                })}
                <span style={{ color: '#ddd', margin: '0 2px' }}>|</span>
                {months.map(item => (
                    <Button key={item.label} size="small" theme="light" onClick={() => applyQuickDate(item.start, item.end)}>{item.label}</Button>
                ))}
            </div>
        );
    };



    return <>

        <Row>
            <RowCol span={24}>{listSumStat()}</RowCol>
        </Row>
        <PaidDateQuickButtons />
        {/* ====== 确认状态筛选按钮 ====== */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', margin: '4px 0 6px', flexWrap: 'wrap' }}>
            <span style={{ color: 'var(--semi-color-text-2)', fontSize: 12, fontWeight: 500 }}>确认状态:</span>
            <Button
                size="small"
                theme={activeConfirmFilter === 'PENDING' ? 'solid' : 'light'}
                type="warning"
                onClick={() => handleConfirmFilterClick('PENDING')}
            >
                待审核 {confirmStatusCounts.PENDING > 0 ? <Badge type='danger' count={confirmStatusCounts.PENDING} style={{ marginLeft: 4 }} /> : null}
            </Button>
            <Button
                    size="small"
                    theme={activeConfirmFilter === 'REJECTED' ? 'solid' : 'light'}
                    type="danger"
                    onClick={() => handleConfirmFilterClick('REJECTED')}
                  >
                    已驳回 {<Badge type='danger' count={confirmStatusCounts.REJECTED?confirmStatusCounts.REJECTED:0} style={{ marginLeft: 4 }} /> }
                  </Button>
            <Button
                    size="small"
                    theme={activeConfirmFilter === 'CANCEL' ? 'solid' : 'light'}
                    type="secondary"
                    onClick={() => handleConfirmFilterClick('CANCEL')}
                  >
                    取消中 {<Badge type='danger' count={confirmStatusCounts.CANCEL?confirmStatusCounts.CANCEL:0} style={{ marginLeft: 4 }} /> }
                  </Button>
            <Button
                    size="small"
                    theme={activeConfirmFilter === 'EDIT' ? 'solid' : 'light'}
                    type="primary"
                    onClick={() => handleConfirmFilterClick('EDIT')}
                  >
                    编辑中 {<Badge type='danger' count={confirmStatusCounts.EDIT?confirmStatusCounts.EDIT:0} style={{ marginLeft: 4 }} /> }
                  </Button>
        </div>

        <Crud
            getCrudApi={(api) => { setCrudApi(api); crudApiRef.current = api; }}
            getFilterFormApi={(_crudApi, formApi) => { filterFormRef.current = formApi; }}
            canUpdate={false}
            canCreate={false}
            canDelete={false}
            canExport={true}
            params={props}
            select={true}
            name="出款明细"
            entityKey="repaymentPlan/listPaid"
            pageSize={50}
            rowActionWidth={0}
            fetchDataAfterMethod={(data: any) => { queryStatCount(data); queryConfirmStatusCount(data); }}
            cols={cols}
            actions={[
                { name: "确认", type: "warning", action: handleConfirmAll },
                { name: "驳回", type: "danger", action: handleReject },
            ]}
        />

        {/* ====== 确认日志弹窗 ====== */}
        <Modal
            title={confirmLogRecord ? `确认状态 - ${confirmLogRecord.leadName}(${confirmLogRecord.leadId}) 第${confirmLogRecord.periodNo}期` : '确认状态'}
            visible={confirmLogModalVisible}
            footer={null}
            onCancel={() => setConfirmLogModalVisible(false)}
            width={900}
        >
            {confirmLogRecord && (
                <div style={{ marginBottom: 20, }}>
                    <div style={{ marginBottom: 16, display: 'flex', gap: 16, alignItems: 'center' }}>
                        <span>当前状态: {renderReviewStatusTag(confirmLogRecord.status)}</span>
                        <span>出款金额: <Text strong>{formatAmountZhCn(confirmLogRecord.paidAmount)}</Text></span>
                        <span>出款人: <Text strong>{confirmLogRecord.paidUserName}</Text></span>
                    </div>
                    <Table
                        rowKey="id"
                        size="small"
                        dataSource={confirmLogs}
                        pagination={false}
                        columns={[
                            { title: "操作时间", dataIndex: "createdAt", width: 160 },
                            {
                                title: "操作类型", dataIndex: "action", width: 120,
                                render: (value: any) => {
                                    if (value === "SUBMIT") return <Tag color="blue" size="small" shape="circle">提交</Tag>;
                                    if (value === "CONFIRM") return <Tag color="green" size="small" shape="circle">确认</Tag>;
                                    if (value === "REJECT") return <Tag color="red" size="small" shape="circle">驳回</Tag>;
                                    if (value === "CANCEL") return <Tag color="cyan" size="small" shape="circle">取消</Tag>;
                                    if (value === "CANCEL_CONFIRM") return <Tag color="teal" size="small" shape="circle">取消确认</Tag>;
                                    if (value === "EDIT") return <Tag color="purple" size="small" shape="circle">编辑</Tag>;
                                    if (value === "EDIT_CONFIRM") return <Tag color="violet" size="small" shape="circle">编辑确认</Tag>;
                                    if (value === "WITHDRAW") return <Tag color="grey" size="small" shape="circle">撤销提交</Tag>;
                                    if (value === "RESUBMIT") return <Tag color="purple" size="small" shape="circle">重新提交</Tag>;
                                    return <Tag size="small">{value}</Tag>;
                                },
                            },
                            {
                                title: "操作说明", dataIndex: "paidOptType", width: 80,
                                render: (value: any) => {
                                    if (value === "HK") return "还款";
                                    if (value === "JQ") return "结清";
                                    if (value === "GZ") return "过账";
                                    return value || '-';
                                },
                            },
                            { title: "操作人", dataIndex: "operatorName", width: 100 },
                            { title: "出款人", dataIndex: "paidUserName", width: 100, render: (value: any) => value || '-' },
                            { title: "状态变化", width: 140, render: (_: any, record: any) => renderStatusTransition(record.previousStatus, record.confirmStatus) },
                            { title: "备注", dataIndex: "remark", render: (value: any) => {
                                    if (!value) return '-';
                                    return value.replace(/\[prev:\w+\]\s*/g, '') || '-';
                                } },
                        ]}
                        bordered
                    />
                </div>
            )}
        </Modal>

        {/* ====== 驳回原因弹窗 ====== */}
        <Modal
            title="驳回原因"
            visible={rejectModalVisible}
            onOk={doReject}
            onCancel={() => setRejectModalVisible(false)}
            okText="确认驳回"
        >
            <TextArea
                placeholder="请输入驳回原因"
                value={rejectReason}
                onChange={setRejectReason}
                rows={4}
                maxLength={200}
                showClear
            />
        </Modal>

    </>
}